module.exports = __webpack_public_path__ + "media/images/orders-4d3e3ced80eb3f6980238f8a7cbfa5b8.svg";